import { Client, Account, Teams } from "appwrite";
import type { Models } from "appwrite";
import { createCachedDatabases, createCachedFunctions, createCachedStorage } from "./offline/appwriteProxy";

const client = new Client()
  .setEndpoint(import.meta.env.VITE_APPWRITE_ENDPOINT)
  .setProject(import.meta.env.VITE_APPWRITE_PROJECT_ID)
  .setDevKey(import.meta.env.DEV_KEY_APPWRITE);


// servicios de appwrite si ncaches
const account = new Account(client);
const teams = new Teams(client);

//servicios de Appwrite con cache
const databases = createCachedDatabases(client);
const functions = createCachedFunctions(client);
const storage = createCachedStorage(client);

const SERVER_TIME_FUNCTION_ID = import.meta.env.VITE_KEY_SERVER_TIME;

export { client, account, databases, teams, functions, storage };


//hora del servidor mediante una funcion de Appwrite

export const getServerTime = async (): Promise<Models.Execution> => {
  if (!SERVER_TIME_FUNCTION_ID) {
    throw new Error('VITE_KEY_SERVER_TIME no está configurado');
  }

  try {
    const response = await functions.createExecution(
      SERVER_TIME_FUNCTION_ID,
      "",
      false,
      "/",
      "GET" as any,
      {}
    );
    return response;
  } catch (error) {
    console.error('Error obteniendo tiempo del servidor:', error);
    throw error;
  }
};



const OTP_VERIFY_FUNCTION_ID = import.meta.env.VITE_KEY_OTP_VERIFY_FUNCTIONS;

export const sendVerifiedOTP = async (email: string): Promise<Models.Execution> => {
  if (!OTP_VERIFY_FUNCTION_ID) {
    throw new Error('VITE_KEY_OTP_VERIFY no está configurado');
  }

  return await functions.createExecution(
    OTP_VERIFY_FUNCTION_ID,
    JSON.stringify({ email }),
    false,
    "/",
    "POST" as any,
    {}
  );
};
